// material
import { styled, alpha } from "@mui/material/styles";
import { Stack, Container, Box, Typography, Button, Grid, Icon, Hidden, Fade, Slide } from "@mui/material";
import SvgIconStyle from "components/SvgIconStyle";
import MContainer from "components/MContainer";
import React, { useState, useRef, useEffect, useLayoutEffect } from 'react';
import LazyLoad from 'react-lazyload';

import { useMediaQuery, IconButton, SvgIcon, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import TouchRipple from '@mui/material/ButtonBase/TouchRipple';
import { ButtonBase } from '@mui/material';

import Lottie, { useLottie } from "lottie-react";
import officeIcon from "../../images/animatedIcons/penAndPaper.json";
import constructionIcon from "../../images/animatedIcons/roadblock.json";
import ppeIcon from "../../images/animatedIcons/personalProtectiveEquipment.json";
import furnitureIcon from "../../images/animatedIcons/furniture.json";
import serverIcon from "../../images/animatedIcons/server.json";
import batteryIcon from "../../images/animatedIcons/battery.json";
import serverIcon2 from "../../images/animatedIcons/server.json";
import officeElectronicsIcon from "../../images/animatedIcons/computer.json";
import appliancesIcon from "../../images/animatedIcons/coffeeMachine.json";
import toolsIcon from "../../images/animatedIcons/ladder.json";
import lightingIcon from "../../images/animatedIcons/wired-outline-36-bulb-hover-blink.json";

// Office Furniture Images
import ThreeDrawerLockingFileCabinet from '../../images/officeFurniture/ThreeDrawerLockingFileCabinet.jpg'
import WaitingRoomChair from '../../images/officeFurniture/WaitingRoomChair.jpg'
import Ergonomic400lbChair from '../../images/officeFurniture/Ergonomic400lbChair.jpg'
import SitStandWorkstationFellowes from '../../images/officeFurniture/SitStandWorkstationFellowes.jfif'
import WalnutBookcase from '../../images/officeFurniture/WalnutBookcase.jpg'
import OfficeCubiclesSunline from '../../images/officeFurniture/OfficeCubiclesSunline.jpg'
import ErgonomicFootrest from '../../images/officeFurniture/ErgonomicFootrest.jfif'
import AntiFatigueMat from '../../images/officeFurniture/AntiFatigueMat.jpg'
import Credenza from '../../images/officeFurniture/Credenza.jpg'
import AleraLogo from '../../images/officeFurniture/Alera.png'
import HonLogo from '../../images/officeFurniture/Hon.jpg'
import ThreeMLogo from '../../images/officeFurniture/3M.jpg'

// Office Electronics Images
import LexmarkLogo from '../../images/officeElectronics/Lexmark.png'
import DellLogo from '../../images/officeElectronics/Dell.png'
import LogitechLogo from '../../images/officeElectronics/Logitech.png'
import OfficeElectronicsImage from '../../images/officeElectronics/OfficeElectronicsDell.png'
import LexmarkPrinter from '../../images/officeElectronics/LexmarkPrinter.jpg'
import HPCartridge from '../../images/officeElectronics/HPCartridge.jpg'
import LogitechKeyboardMouse from '../../images/officeElectronics/LogitechKeyboardMouse.jpg'
import Monitor from '../../images/officeElectronics/Monitor.jpeg'
import LogitechWebcam from '../../images/officeElectronics/LogitechWebcam.jpg'
import LogitechHeadset from '../../images/officeElectronics/LogitechHeadset.jpg'
import Projector from '../../images/officeElectronics/Projector.jpg'
import Scanner from '../../images/officeElectronics/Scanner.png'

// Appliances Images
import PrimaryAppliances from '../../images/appliances/primaryAppliances.png'
import CoffeeMaker from '../../images/appliances/CoffeeMaker.jpg'
import Microwave from '../../images/appliances/Microwave.jpg'
import Refrigerator from '../../images/appliances/Refrigerator.png'
import WaterCooler from '../../images/appliances/WaterCooler.jpg'
import AirPurifier from '../../images/appliances/AirPurifier.jpg'
import OfficeFan from '../../images/appliances/OfficeFan.jpg'
import Heater from '../../images/appliances/Heater.jpg'
import Dehumidifier from '../../images/appliances/Dehumidifier.jpg'
import HoneywellLogo from '../../images/appliances/Honeywell.png'
import KeurigLogo from '../../images/appliances/Keurig.png'
import FrigidaireLogo from '../../images/appliances/Frigidaire.png'

// Lighting & Filters Images
import LightingPrimary from '../../images/lighting/lightingPrimary.png'
import LEDLamp from '../../images/lighting/LEDLamp.jpg'
import CeilingLight from '../../images/lighting/CeilingLight.jpg'
import TaskLighting from '../../images/lighting/TaskLighting.png'
import AirFilter from '../../images/lighting/AirFilter.jpg'
import UVsanitizer from '../../images/lighting/UVsanitizer.jpg'
import OutdoorLighting from '../../images/lighting/OutdoorLighting.png'
import HVACFilter from '../../images/lighting/HVACFilter.png'
import SmartBulb from '../../images/lighting/SmartBulb.jpg'
import GELogo from '../../images/lighting/GELogo.png'
import PhilipsLogo from '../../images/lighting/PhilipsLogo.png'
import SylvaniaLogo from '../../images/lighting/SylvaniaLogo.png'

// Batteries & UPS Systems Images
import BatteriesPrimary from '../../images/batteries/batteriesPrimary.png'
import DeltaUPSSystem from '../../images/batteries/Delta-UPS-System.jpg'
import RechargableBatteries from '../../images/batteries/RechargableBatteries.jpg'
import AlkalineBatteries from '../../images/batteries/AlkalineBatteries.jpg'
import PowerBank from '../../images/batteries/PowerBank.jpg'
import SurgeProtector from '../../images/batteries/SurgeProtector.jpg'
import BatteryCharger from '../../images/batteries/BatteryCharger.png'
import Multimeter from '../../images/batteries/Multimeter.png'
import BatteryReplacement from '../../images/batteries/BatteryReplacement.png'
import APCLogo from '../../images/batteries/APCLogo.png'
import CDLogo from '../../images/batteries/C&DLogo.png'
import FlukeLogo from '../../images/batteries/FlukeLogo.png'

// Networking & Server Equipment Images
import NetworkingPrimary from '../../images/networking/networkingPrimary.png'
import HPERouter from '../../images/networking/HPERouter.jpg'
import HPEswitches from '../../images/networking/HPEswitches.jpg'
import Modem from '../../images/networking/Modem.jpg'
import Firewall from '../../images/networking/Firewall.jpg'
import Server from '../../images/networking/server.jpg'
import CloudServices from '../../images/networking/Cloudservices.png'
import NetworkAdapter from '../../images/networking/Networkadapter.png'
import ServerRacks from '../../images/networking/Serverracks.png'
import CiscoLogo from '../../images/networking/CiscoLogo.png'
import HPELogo from '../../images/networking/HPELogo.png'
import DellTechLogo from '../../images/networking/DellTechLogo.png'

// Construction & Electrical Images
import PrimaryConstruction from '../../images/constructionElectrical/primaryConstruction.png'
import PowerTools from '../../images/constructionElectrical/Powertools.jpg'
import MessageBoard from '../../images/constructionElectrical/MessageBoard.png'
import Conduit from '../../images/constructionElectrical/Conduit.png'
import Handholes from '../../images/constructionElectrical/Handholes.png'
import Unistrut from '../../images/constructionElectrical/Unistrut.png'
import HVACequipment from '../../images/constructionElectrical/HVACequipment.png'
import Plumbing from '../../images/constructionElectrical/plumbing.png'
import ElectricalWiring from '../../images/constructionElectrical/electricalWiring.png'
import FiberOptics from '../../images/constructionElectrical/Fiberoptics.png'
import SchneiderElectricLogo from '../../images/constructionElectrical/SchneiderElectricLogo.png'
import MilwaukeeLogo from '../../images/constructionElectrical/MilwaukeeLogo.png'
import OldCastleLogo from '../../images/constructionElectrical/OldCastleLogo.png'

// Safety & Tactical Gear Images
import PrimarySafety from '../../images/safetyTacticalGear/primarySafety.png'
import HardHat from '../../images/safetyTacticalGear/HardHat.jpg'
import SafetyGlasses from '../../images/safetyTacticalGear/safetyGlasses.jpg'
import WorkGloves from '../../images/safetyTacticalGear/workGloves.png'
import SafetyVest from '../../images/safetyTacticalGear/safetyVest.jpg'
import Respirator from '../../images/safetyTacticalGear/respirator.png'
import FirstAidKit from '../../images/safetyTacticalGear/firstAidKit.jpg'
import Flashlight from '../../images/safetyTacticalGear/flashlights.png'
import Radio from '../../images/safetyTacticalGear/radio.png'
import KleinToolsLogo from '../../images/safetyTacticalGear/KleinToolsLogo.png'
import MoldexLogo from '../../images/safetyTacticalGear/MoldexLogo.png'
// Professional Solutions Images
import PrimarySolutions from '../../images/professionalSolutions/primarySolutions.png'
import MaintenanceRepairs from '../../images/professionalSolutions/maintenanceRepairs.png'
import InstallationSetup from '../../images/professionalSolutions/installationSetup.png'
import PaintServices from '../../images/professionalSolutions/paintServices.png'
import AVintegration from '../../images/professionalSolutions/AVintegration.png'
import ITnetworking from '../../images/professionalSolutions/ITnetworking.png'
import AIautomation from '../../images/professionalSolutions/AI.png'
import CustomManufacturing from '../../images/professionalSolutions/customManufacturing.png'
import Flooring from '../../images/professionalSolutions/Flooring.png'
import HPEGreenlakeLogo from '../../images/professionalSolutions/HPEGreenlakeLogo.png'
import AzureLogo from '../../images/professionalSolutions/AzureLogo.png'
// ----------------------------------------------------------------------

const SectionTitle = styled(Typography)(({ theme }) => ({
  position: 'relative',
  display: 'inline-block',
  marginBottom: theme.spacing(5),
  '&:after': {
    content: '""',
    position: 'absolute',
    bottom: '-10px',
    left: '0',
    width: '60px',
    height: '4px',
    backgroundColor: theme.palette.primary.main,
    borderRadius: '2px',
  }
}));

export default function Products() {
  const contentRef = useRef(null);
  const [isSticky, setIsSticky] = useState(false);
  const [elementOffset, setElementOffset] = useState(0);
  
  useLayoutEffect(() => {
    const calculateOffset = () => {
      if (contentRef.current) {
        const rect = contentRef.current.getBoundingClientRect();
        const offset = rect.top + window.pageYOffset;
        setElementOffset(offset);
      }
    };
  
    calculateOffset();
    window.addEventListener('resize', calculateOffset);
  
    const handleScroll = () => {
      const scrollPosition = window.pageYOffset;
      const buffer = 200; // Adjust this value as needed
      setIsSticky(scrollPosition > elementOffset - buffer);
    };
  
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', calculateOffset);
    };
  }, [elementOffset]);

    const GridItem = styled(Box)(({ theme }) => ({
      padding: theme.spacing(2),
      textAlign: 'center',
      position: 'relative',
      '&:nth-of-type(-n+3)::after': {
          content: '""',
          position: 'absolute',
          top: 67,
          right: 0,
          height: '112%',
          width: '2px',
          backgroundColor: 'lightblue',
          borderRadius: '50%',
      }
    
    }));

    const GridContainer = styled(Grid)(({ theme }) => ({
      position: 'relative',
      marginTop:25,
      '&::after': {
        content: '""',
        position: 'absolute',
        top: -15,
        left: 45,
        width: 'calc(100% - 90px)',
        height: '2px',
        backgroundColor: 'lightblue',
        borderRadius: '50%',
      },
    }));
  const productCategories = [
    {
      icon: furnitureIcon,
      label: 'Office Furniture',
      sublabel: 'Premium office furniture from ergonomic chairs to custom cubicles. Expert consultation, space planning, and installation services.',
      image: Credenza,
      topBrands: [
        { image: AleraLogo, link: 'https://www.alerafurniture.com/' },
        { image: HonLogo, link: 'https://www.hon.com/' },
        { image: ThreeMLogo, link: 'https://www.3m.com/' }
      ],
      products: [
        { label: 'File Cabinets', image: ThreeDrawerLockingFileCabinet },
        { label: 'Waiting Room', image: WaitingRoomChair },
        { label: 'Ergonomic Chairs', image: Ergonomic400lbChair },
        { label: 'Standing Desks', image: SitStandWorkstationFellowes },
        { label: 'Bookcases', image: WalnutBookcase },
        { label: 'Cubicles', image: OfficeCubiclesSunline },
        { label: 'Footrests', image: ErgonomicFootrest },
        { label: 'Anti-Fatigue Mats', image: AntiFatigueMat },
      ]
    },
    {
      icon: officeElectronicsIcon,
      label: 'Office Electronics',
      sublabel: 'Premium office technology solutions from printers to conferencing systems.',
      image: OfficeElectronicsImage,
      topBrands: [
        { image: LexmarkLogo, link: 'https://www.lexmark.com/' },
        { image: DellLogo, link: 'https://www.dell.com/' },
        { image: LogitechLogo, link: 'https://www.logitech.com/' }      ],
      products: [
        { label: 'Printers', image: LexmarkPrinter },
        { label: 'Toner', image: HPCartridge },
        { label: 'Keyboards & Mice', image: LogitechKeyboardMouse },
        { label: 'Monitors', image: Monitor },
        { label: 'Webcams', image: LogitechWebcam },
        { label: 'Headsets', image: LogitechHeadset },
        { label: 'Projectors', image: Projector },
        { label: 'Scanners', image: Scanner },
      ]
    },
    {
      icon: appliancesIcon,
      label: 'Appliances',
      sublabel: 'Enhance your office comfort with our range of appliances - from coffee makers to air purifiers, we\'ve got you covered.',
      image: PrimaryAppliances,
      topBrands: [
        { image: KeurigLogo, link: 'https://www.keurig.com/' },
        { image: FrigidaireLogo, link: 'https://www.frigidaire.com/' },
        { image: HoneywellLogo, link: 'https://www.honeywell.com/us/en' }
      ],
      products: [
        { label: 'Coffee Makers', image: CoffeeMaker },
        { label: 'Microwaves', image: Microwave },
        { label: 'Refrigerators', image: Refrigerator },
        { label: 'Water Coolers', image: WaterCooler },
        { label: 'Air Purifiers', image: AirPurifier },
        { label: 'Fans', image: OfficeFan },
        { label: 'Heaters', image: Heater },
        { label: 'Dehumidifiers', image: Dehumidifier },
      ]
    },
    {
      icon: lightingIcon,
      label: 'Lighting & Filters',
      sublabel: 'Illuminate your workspace and improve air quality with our selection of lighting solutions and air filters.',
      image: LightingPrimary,
      topBrands: [
        { image: PhilipsLogo, link: 'https://www.philips.com/' },
        { image: SylvaniaLogo, link: 'https://www.sylvania.com/' },
        { image: GELogo, link: 'https://www.gelighting.com/' }
      ],
      products: [
        { label: 'LED Desk Lamps', image: LEDLamp },
        { label: 'Ceiling Lights', image: CeilingLight },
        { label: 'Task Lighting', image: TaskLighting },
        { label: 'Air Filters', image: AirFilter },
        { label: 'UV Sanitizers', image: UVsanitizer },
        { label: 'Smart Bulbs', image: SmartBulb },
        { label: 'Outdoor Lighting', image: OutdoorLighting },
        { label: 'HVAC Filters', image: HVACFilter },
      ]
    },
    {
      icon: batteryIcon,
      label: 'Batteries & UPS Systems',
      sublabel: 'Ensure uninterrupted power supply and device functionality with our range of batteries and UPS systems.',
      image: BatteriesPrimary,
      topBrands: [
        { image: APCLogo, link: 'https://www.apc.com/' },
        { image: CDLogo, link: 'https://www.cdtechno.com/' },
        { image: FlukeLogo, link: 'https://www.fluke.com/' }
      ],
      products: [
        { label: 'UPS Systems', image: DeltaUPSSystem },
        { label: 'Rechargeable Batteries', image: RechargableBatteries },
        { label: 'Alkaline Batteries', image: AlkalineBatteries },
        { label: 'Battery Chargers', image: BatteryCharger },
        { label: 'Power Banks', image: PowerBank },
        { label: 'Surge Protectors', image: SurgeProtector },
        { label: 'Multimeters', image: Multimeter },
        { label: 'Battery Replacement', image: BatteryReplacement },
      ]
    },
    {
      icon: serverIcon2,
      label: 'Networking & Servers',
      sublabel: 'Build a robust IT infrastructure with our comprehensive range of networking and server equipment.',
      image: NetworkingPrimary,
      topBrands: [
        { image: CiscoLogo, link: 'https://www.cisco.com/' },
        { image: HPELogo, link: 'https://www.hpe.com/us/en/home.html' },
        { image: DellTechLogo, link: 'https://www.dell.com/en-us/dt/servers/index.htm' }
      ],
      products: [
        { label: 'Routers', image: HPERouter },
        { label: 'Switches', image: HPEswitches },
        { label: 'Servers', image: Server },
        { label: 'Cloud Services', image: CloudServices },
        { label: 'Modems', image: Modem },
        { label: 'Firewalls', image: Firewall },
        { label: 'Network Adapters', image: NetworkAdapter },
        { label: 'Server Racks', image: ServerRacks },
      ]
    },
    {
      icon: constructionIcon,
      label: 'Construction & Electrical',
      sublabel: 'Find all your construction and electrical needs for office renovations and maintenance in one place.',
      image: PrimaryConstruction,
      topBrands: [
        { image: MilwaukeeLogo, link: 'https://www.milwaukeetool.com/' },
        { image: SchneiderElectricLogo, link: 'https://www.schneider-electric.com/' },
        { image: OldCastleLogo, link: 'https://www.oldcastle.com/' }
      ],
      products: [
        { label: 'Power Tools', image: PowerTools },
        { label: 'Electrical Wiring', image: ElectricalWiring },
        { label: 'Handholes', image: Handholes },
        { label: 'HVAC Equipment', image: HVACequipment },
        { label: 'Plumbing Supplies', image: Plumbing },
        { label: 'Fiber Optics', image: FiberOptics },
        { label: 'Conduit', image: Conduit },
        { label: 'Unistrut', image: Unistrut },
      ]
    },
    {
      icon: ppeIcon,
      label: 'Safety & Tactical Gear',
      sublabel: 'Prioritize workplace safety with our comprehensive range of personal protective equipment and tactical gear.',
      image: PrimarySafety,
      topBrands: [
        { image: ThreeMLogo, link: 'https://www.3m.com/3M/en_US/worker-health-safety-us/' },
        { image: MoldexLogo, link: 'https://www.moldex.com/' },
        { image: KleinToolsLogo, link: 'https://www.kleintools.com/' }
      ],
      products: [
        { label: 'Hard Hats', image: HardHat },
        { label: 'Safety Glasses', image: SafetyGlasses },
        { label: 'Work Gloves', image: WorkGloves },
        { label: 'Safety Vests', image: SafetyVest },
        { label: 'Respirators', image: Respirator },
        { label: 'First Aid Kits', image: FirstAidKit },
        { label: 'Flashlights', image: Flashlight },
        { label: 'Radios', image: Radio },
      ]
    },
    {
      icon: toolsIcon,
      label: 'Professional Solutions',
      sublabel: 'Delivering expert service and innovative solutions tailored to your projects unique needs.',
      image: PrimarySolutions,
      topBrands: [
        { image: CiscoLogo, link: 'https://www.cisco.com/' },
        { image: HPEGreenlakeLogo, link: 'https://www.hpe.com/us/en/greenlake.html' },
        { image: AzureLogo, link: 'https://azure.microsoft.com/' }
      ],
      products: [
        { label: 'Maintenance', image: MaintenanceRepairs },
        { label: 'Installation & Setup', image: InstallationSetup },
        { label: 'Flooring Solutions', image: Flooring },
        { label: 'Painting Services', image: PaintServices },
        { label: 'AV Integration', image: AVintegration },
        { label: 'IT & Networking', image: ITnetworking },
        { label: 'AI & Automation', image: AIautomation },
        { label: 'Custom Products', image: CustomManufacturing },
      ]
    },
  ];

  const lottieRefs = useRef(productCategories.map(() => React.createRef()));

  const [selectedCategory, setSelectedCategory] = useState(productCategories[0]);
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));

  const [in1, setIn1] = useState(true);

  const handleCategoryClick = (category) => {
    console.log('Selected category:', category);
    setIn1(false);
    setTimeout(() => {
      setSelectedCategory(category);
      setTimeout(() => {
        setIn1(true);
      }, 200);
    }, 200);
  };

  const getCategoryDescription = (category) => {
    switch (category.label) {
      case 'Office Furniture':
        return 'Desks, chairs, filing cabinets, cubicles, conference tables';
      case 'Office Electronics':
        return 'Printers, toner, projectors, TVs, monitors, radios';
      case 'Appliances':
        return 'Refrigerators, freezers, microwaves, coffee makers';
      case 'Lightbulbs & Air Filters':
        return 'Lightbulbs, air filters, water filters, lighting fixtures';
      case 'Batteries & UPS Systems':
        return 'Various battery types, chargers, power banks, UPS systems';
      case 'Networking & Servers':
        return 'Cisco routers, switches, servers, racks, cables';
      case 'Construction & Electrical':
        return 'Cabling, hand holes, conduit, fiber optics, underground enclosures';
      case 'Safety & Tactical Gear':
        return '3M coveralls, gas masks, arc flash kits, body armor, handcuffs, batons';
      case 'Tools & Equipment':
        return 'Hand tools, power tools, testing equipment, pool equipment';
      default:
        return 'Description not available';
    }
  };
  

  const renderDesktopView = () => (
    <>
    
    <Grid item sm={6} xs={12}>
      <Box sx={{ position: "relative", py: 2 }}>
        <SectionTitle variant="h2" color="text.primary">
          Products and Services
        </SectionTitle>
      </Box>
    </Grid>
    <Grid container spacing={10}>
      <Grid item xs={12} md={4}>
        <Grid container spacing={2}>
          {productCategories.map((category, index) => (
            <Grid item xs={4} key={category.label}>
              <ButtonBase
                onClick={() => {
                  handleCategoryClick(category);
                  lottieRefs.current[index].current?.stop();
                  lottieRefs.current[index].current?.play();
                }}
                
                sx={{
                  position: 'relative',
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '10px',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  margin: '10px',
                  backgroundColor: 'background.paper',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.08)',
                  border: selectedCategory.label === category.label ? '2px solid #A3E7FD' : '2px solid transparent',
                  boxSizing: 'border-box',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',                  
                  '&:hover': {
                    transform: 'translateY(-8px)',
                    boxShadow: '0 8px 16px rgba(0, 0, 0, 0.12)',
                    '& .MuiTypography-root': { color: 'primary.main' }
                  }
                }}                
              >
                <Lottie 
                  lottieRef={lottieRefs.current[index]}
                  animationData={category.icon} 
                  loop={false} 
                  autoplay={false}
                />    
                <Typography 
                  variant="caption" 
                  sx={{ 
                    position: 'relative', 
                    zIndex: 2, 
                    mt: 1, 
                    height: '40px', 
                    display: 'flex', 
                    alignItems: 'center', 
                    justifyContent: 'center', 
                    textAlign: 'center' 
                  }}
                >
                  {category.label}
                </Typography>                
                <TouchRipple center={false} />
              </ButtonBase>
            </Grid>
          ))}
        </Grid>
      </Grid>
      <Grid item xs={12} md={8} >  
        
<Fade in={in1} timeout={200}>
  <div>             
        <Box sx={{ display: 'flex', alignItems: 'flex-start', mt: 2, ml:6, mr: 6 }}>
          <Box sx={{ flex: 1 }}>
            <Typography variant="h4">{selectedCategory.label}</Typography>
            <Typography variant="h5" sx={{ color: 'black' }}>{selectedCategory.sublabel}</Typography>
            <Typography variant="subtitle2" noWrap sx={{ mt: 2 }}><strong>Top Brands</strong></Typography>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: -1 }}>
              {selectedCategory.topBrands.map((brand, index) => (
                <Box
                  key={index}
                  component="a"
                  href={brand.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{
                    width: '30%',
                    height: '100px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <Box
                    component="img"
                    src={brand.image}
                    alt={`Brand ${index + 1}`}
                    sx={{
                      maxWidth: '100%',
                      maxHeight: '100%',
                      objectFit: 'contain',
                      filter: 'saturate(70%)',
                      transition: 'filter 0.3s ease',
                      '&:hover': {
                        filter: 'saturate(100%)',
                      },
                    }}
                  />
                </Box>
              ))}
            </Box>

          </Box>
          <Box component="img" src={selectedCategory.image} alt={selectedCategory.label}sx={{ width: '33.333%', ml: 3 }} />
        </Box>
        <GridContainer container spacing={0}>
          {selectedCategory.products.map((product, index) => (
            <Grid item xs={3} key={index}>
                <GridItem 
                  sx={{
                    ...(index > 3 || (index + 1) % 4 === 0 || (index + 1) % 8 === 0 ? { '&::after': { display: 'none' } } : {})
                  }}
                >
                  <LazyLoad 
                    height={100} 
                    once 
                    offset={100}
                    placeholder={<div style={{height: 100, background: '#f0f0f0'}}></div>}
                  >
                  <img src={product.image} alt={product.label} style={{ width: '100%', height: '100px', objectFit: 'scale-down', mixBlendMode: 'multiply' }} />   
                  </LazyLoad>                   
                <Typography variant="subtitle2" noWrap><strong>{product.label}</strong></Typography>
              </GridItem>
            </Grid>
          ))}
        </GridContainer>    
      </div>
</Fade>    
      </Grid>
    </Grid>
    </>
  );

  const renderMobileView = () => (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', ml:'-32px' }}>
      <Box sx={{
        position: 'relative',
        transform: {
          xs: 'scale(0.6)',
          sm: 'scale(0.7)',
          md: 'scale(0.8)'
        },
        marginRight: -2,
        marginTop: -1
      }}>            
      </Box>
      <Typography component="span" variant="h2" color="primary" style={{position:'relative',zIndex:2}} sx={{ fontSize: { xs: '1.75rem', sm: '2.5rem' } }}>
          Products and Services
      </Typography>
    </Box>    
      {productCategories.map((category) => (
        <Accordion key={category.label}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <SvgIconStyle src={category.icon} sx={{ width: 24, height: 24, position: 'relative', zIndex: 2 }} />
            <Typography>{category.label}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box component="img" src={`/images/${category.icon}.png`} sx={{ width: '100%', mb: 2 }} />
            <Typography>
              {getCategoryDescription(category)}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
      
    </Box>
  );
  const renderMobileView2 = () => (
    <>
    <Box sx={{ display: 'flex', alignItems: 'center', ml:'32px', mb:'20px' }}>
      <Box sx={{
        position: 'relative',
        transform: {
          xs: 'scale(0.6)',
          sm: 'scale(0.7)',
          md: 'scale(0.8)'
        },
        marginRight: 4,
        marginTop: -3.5
      }}>       
      </Box>
      <SectionTitle variant="h2" color="text.primary" sx={{ fontSize: { xs: '1.55rem', sm: '2.5rem' } }}>
          Products & Services
      </SectionTitle>
    </Box>    
    <Grid container spacing={0}>
      <Grid item xs={2} md={2}>
        <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            paddingBottom: '0px',
            marginBottom: '-12px'
          }}>
          {productCategories.map((category, index) => (
            <ButtonBase
              key={category.label}
              onClick={() => {
                handleCategoryClick(category);
                lottieRefs.current[index].current?.stop();
                lottieRefs.current[index].current?.play();
              }}
              sx={{
                width: '70px',
                height: '70px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '2px',
                borderRadius: '8px',
                overflow: 'hidden',
                margin: '4px 0',
                backgroundColor: 'background.paper',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
                border: selectedCategory.label === category.label ? '2px solid #A3E7FD' : '2px solid transparent',
                boxSizing: 'border-box',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',                  
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.12)',
                  '& .MuiTypography-root': { color: 'primary.main' }
                }
              }}                
            >
              <Lottie 
                lottieRef={lottieRefs.current[index]}
                animationData={category.icon} 
                loop={false} 
                autoplay={false}
                style={{ width: '70%', height: '70%' }}
              />    
              <Typography 
                variant="caption" 
                sx={{ 
                  position: 'relative', 
                  zIndex: 2, 
                  mt: 0.2, 
                  height: '20px', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center', 
                  textAlign: 'center',
                  fontSize: '0.6rem'
                }}
              >
                {category.label}
              </Typography>                
              <TouchRipple center={false} />
            </ButtonBase>
          ))}
        </Box>
      </Grid>
      <Grid item xs={10} md={10}>  
        <Fade in={in1} timeout={200} >
          <Box  sx={{ height: '100%' }}>

          <Box 
            ref={contentRef}
            sx={{ 
              position: 'sticky',
              top: 110,
              width: '88.33%',
              padding: '5px',
              margin: 'auto',
              overflowY: 'auto',
              borderRadius:'10px',
              transition: 'box-shadow 0.3s ease-out, transform 0.3s ease-out, background-color 0.3s ease-out',
              boxShadow: isSticky ? ' 0 1px 2px rgba(0,0,0, 0.25)' : 'none',
              transform: isSticky ? 'scale(1.03)' : 'scale(1)',
              backgroundColor: isSticky ? 'transparent' : 'transparent',
            }}
            >
            
                      <Box sx={{ 
                        display: 'flex', 
                        alignItems: 'flex-start', 
                        mt: 2, 
                        ml: { xs: 2, sm: 1, md: 6 }, 
                        mr: { xs: 0, sm: 1, md: 6 } 
                      }}>              <Box sx={{ flex: 1 }}>
                <Typography variant="h4">{selectedCategory.label}</Typography>
                <Typography variant="h5" sx={{ color: 'black' }}>{selectedCategory.sublabel}</Typography>
                <Typography variant="subtitle2" noWrap sx={{ mt: 2 }}><strong>Top Brands</strong></Typography>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: -1 }}>
                  {selectedCategory.topBrands.map((brand, index) => (
                    <Box
                      key={index}
                      component="a"
                      href={brand.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      sx={{
                        width: '30%',
                        height: '100px',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <Box
                        component="img"
                        src={brand.image}
                        alt={`Brand ${index + 1}`}
                        sx={{
                          maxWidth: '100%',
                          maxHeight: '100%',
                          objectFit: 'contain',
                          filter: 'saturate(70%)',
                          transition: 'filter 0.3s ease',
                          '&:hover': {
                            filter: 'saturate(100%)',
                          },
                        }}
                      />
                    </Box>
                  ))}
                </Box>
              </Box>
              <Box component="img" src={selectedCategory.image} alt={selectedCategory.label} sx={{ width: '33.333%', ml: { xs: 0, sm: 1.5, md: 3 } }} /></Box>
            <GridContainer container spacing={0} sx={{mt:0}}>
              {selectedCategory.products.map((product, index) => (
                <Grid item xs={3} key={index}>
                    <GridItem 
                      sx={{
                        ...(index > 3 || (index + 1) % 4 === 0 || (index + 1) % 8 === 0 ? { '&::after': { display: 'none' } } : {}),
                        padding:'5px',
                      }}
                    >
                      <img src={product.image} alt={product.label} style={{ width: '100%', height: '70px', objectFit: 'scale-down' }} />                      
                      <p style={{ fontSize: '0.5rem', lineHeight: '1.2em', fontWeight: 'bold', width:'100%', margin:'auto' }}>{product.label}</p>
                    </GridItem>                
                </Grid>
              ))}
            </GridContainer>    
          </Box>
          </Box>
        </Fade>    
      </Grid>
    </Grid>
    </>
  );

  return (
    <MContainer id="products" className="paddedSection" sx={{ position: "relative", pt: 12, pb: 0 }}>
      {isMobile ? renderMobileView2() : renderDesktopView()}
    </MContainer>
  );
}
